import {Component, OnInit} from '@angular/core';
import {QedMulticastList} from '../../models/qedMulticastList';
import {AbstractControl, UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {UtilsService} from '../../appSharedModule/services/utils.service';
import * as _ from 'lodash';
import {SymbolsService} from '../../services/symbols.service';
import {environment} from '../../../environments/environment';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {saveAs} from 'file-saver';
import {DatePipe} from '@angular/common';
import {QedMulticast} from '../../models/qedMulticast';
import {QedSymbolsInfo} from '../../models/qedSymbolsInfo';
import {AuthenticationService} from '../../authenticationModule/services/authentication.service';
import {BaseClientComponent} from '../base-client.component';

@Component({
  selector: 'app-qed-multicast-list',
  templateUrl: './qed-multicast-list.component.html',
  styleUrls: ['./qed-multicast-list.component.scss'],
  host: {class: 'sym-page sym-multicast'}
})
export class QedMulticastListComponent extends BaseClientComponent implements OnInit {

  researchForm: UntypedFormGroup;
  listQedMulticasts: QedMulticast[] = [];
  popListDropdown = [];
  arbitrationPopListDropDown = [];
  popList = [];
  arbitrationPopList = [];
  channel = '';
  platformOptions = ['All', 'Prod only', 'UAT only'];
  encryptionOptions = ['All', 'Non-Encrypted', 'Encrypted'];
  protectionOptions = ['All', 'Non-Protected', 'Protected'];
  cols = [];
  qedSymbolsInfo: QedSymbolsInfo;
  alertQedSymbolHasNotChanged = false;
  downloadOption = 'dateRange';
  qedMulticastList: QedMulticastList[];
  arbitratedQedMulticastList: QedMulticastList[];
  filteredQedMulticastList: QedMulticastList[] = [];
  filteredValuesArbitrated: QedMulticastList[] = [];
  qedSymbolsInfoData: any;
  minDateForCalendar: Date = new Date('2015-01-01');
  maxDateForCalendar: Date = null;
  startDates: string[];
  dateArray: any[];
  disabledDatesInCalendar: any[];
  isQhf = false;
  displayPastListsDialog = false;

  userChoicesFiltersDefaultQedMulticast = {
    pop: null,
    channel: '',
    ipAddress1: '',
    ipAddress2: '',
    ipAddress3: '',
    ipAddress4: '',
    platform: 'All',
    encryption: 'All',
    protection: 'All'
  };

  userChoicesActiveFilters = _.clone(this.userChoicesFiltersDefaultQedMulticast);
  updateOnDate: string;

  constructor(private route: ActivatedRoute,
              private utilsService: UtilsService,
              public authenticationService: AuthenticationService,
              private router: Router,
              private httpClient: HttpClient,
              private datePipe: DatePipe,
              private symbolsService: SymbolsService,
              private formBuilder: UntypedFormBuilder) {
    super();
    this.cols = [
      {field: 'pop', header: 'POP'},
      {field: 'channel', header: 'Channel'},
      {field: 'nonCryptProtProd', header: 'Non-Encrypted Protected Prod'},
      {field: 'nonCryptProtUat', header: 'Non-Encrypted Protected UAT'},
      {field: 'nonCryptNonProtProd', header: 'Non-Encrypted Non-Protected Prod'},
      {field: 'nonCryptNonProtUat', header: 'Non-Encrypted Non-Protected UAT'},
      {field: 'cryptProtProd', header: 'Encrypted Protected Prod'},
      {field: 'cryptProtUat', header: 'Encrypted Protected UAT'},
      {field: 'cryptNonProtProd', header: 'Encrypted Non-Protected Prod'},
      {field: 'cryptNonProtUat', header: 'Encrypted Non-Protected UAT'},
      {field: 'arbitrated', header: 'Arbitration'}
    ];
    this.maxDateForCalendar = new Date();
    this.maxDateForCalendar.setMonth(this.maxDateForCalendar.getMonth() + 1);
  }

  get popForm(): AbstractControl {
    return this.getForm('pop');
  }

  get channelForm(): AbstractControl {
    return this.getForm('channel');
  }

  get ipAddress1Form(): AbstractControl {
    return this.getForm('ipAddress1');
  }

  get ipAddress2Form(): AbstractControl {
    return this.getForm('ipAddress2');
  }

  get ipAddress3Form(): AbstractControl {
    return this.getForm('ipAddress3');
  }

  get ipAddress4Form(): AbstractControl {
    return this.getForm('ipAddress4');
  }

  get platformForm(): AbstractControl {
    return this.getForm('platform');
  }

  get encryptionForm(): AbstractControl {
    return this.getForm('encryption');
  }

  get protectionForm(): AbstractControl {
    return this.getForm('protection');
  }

  get pastDateRange1Form(): AbstractControl {
    return this.getForm('pastDateRange1');
  }

  get pastDateRange2Form(): AbstractControl {
    return this.getForm('pastDateRange2');
  }

  ngOnInit() {
    this.utilsService.lockUi();
    this.isQhf = !!this.route.snapshot.data['qhfOnly'];
    this.route.queryParams.subscribe(params => {
      const channelGetParameter = (params['channel']) ? params['channel'] : '';
      const addressGetParameter = (params['multicast_group']) ? params['multicast_group'] : '';

      this.userChoicesActiveFilters = this.utilsService.loadUserPref('qedMulticastFilter', this.userChoicesFiltersDefaultQedMulticast);
      this.initializeResearchForm(channelGetParameter, addressGetParameter, this.userChoicesActiveFilters);
    });
    const response$ = this.authenticationService.waitForAuthenticationThenLaunch(() => {
      this.getQedSymbolStartDate();
    });
    this.subscriptions.push(response$);
  }

  public getDatesArray() {
    this.dateArray = [];
    const currentDate = this.minDateForCalendar;
    const stopDate = this.maxDateForCalendar;
    while (currentDate <= stopDate) {
      this.dateArray.push(this.datePipe.transform(currentDate, 'yyyy-MM-dd'));
      currentDate.setDate(currentDate.getDate() + 1);
    }
  }

  redirectionToNotFound() {
    this.router.navigate(['/404']);
  }

  resetTable(): void {
    // Filter
    this.popForm.setValue('');
    this.channelForm.setValue('');
    this.ipAddress1Form.setValue('');
    this.ipAddress2Form.setValue('');
    this.ipAddress3Form.setValue('');
    this.ipAddress4Form.setValue('');
    this.platformForm.setValue('All');
    this.encryptionForm.setValue('All');
    this.protectionForm.setValue('All');
    this.filterMulticastList();
  }

  removeDuplicates(popNames) {
    const uniquePopName = {};
    popNames.forEach(function (i) {
      if (!uniquePopName[i]) {
        uniquePopName[i] = true;
      }
    });
    return Object.keys(uniquePopName);
  }

  createChannelListForPop(pop, arbitration = false) {
    const list = this.listQedMulticasts
      .filter(qedMulticast => qedMulticast.popName === pop && qedMulticast.arbitration === arbitration)
      .map(qedMulticast => qedMulticast.qedChannel.name)
      .sort();
    return this.removeDuplicates(list);
  }

  getMulticastValues(qedMulticasts, platform, arbitration = false) {
    let displayedValue = '';

    const multicast: QedMulticast[] = qedMulticasts
      .filter(qedMulticast => qedMulticast.platform === platform);
    if (this.getPortOrMcastIp(multicast, arbitration).length > 0) {
      displayedValue = this.getPortOrMcastIp(multicast, arbitration) + '/' + this.getRawQedPort(multicast);
    }
    return displayedValue;
  }

  getRawQedPort(multicastNonProt) {
    return (multicastNonProt.length > 0) ? multicastNonProt[0].port : '';
  }

  createMulticastList(arbitrated = false) {
    const pops = (!arbitrated) ? this.popList : this.arbitrationPopList;
    const multicastList: QedMulticastList[] = [];
    for (const pop of pops) {
      for (const channel of this.createChannelListForPop(pop, arbitrated)) {
        const multicastNonProt: QedMulticast[] = this.listQedMulticasts.filter(qedMulticast =>
          qedMulticast.popName === pop
          && qedMulticast.qedChannel.name === channel
          && qedMulticast.arbitration === arbitrated
          && qedMulticast.isProtected === false);
        const multicastProt: QedMulticast[] = this.listQedMulticasts.filter(qedMulticast =>
          qedMulticast.popName === pop
          && qedMulticast.qedChannel.name === channel
          && qedMulticast.arbitration === arbitrated
          && qedMulticast.isProtected === true);
        const multicast: QedMulticastList = {
          pop: pop,
          channel: channel,
          cryptProtProd: this.getMulticastValues(multicastProt, 'crypt_prod', arbitrated),
          cryptProtUat: this.getMulticastValues(multicastProt, 'crypt_uat', arbitrated),
          nonCryptProtProd: this.getMulticastValues(multicastProt, 'prod', arbitrated),
          nonCryptProtUat: this.getMulticastValues(multicastProt, 'uat', arbitrated),
          nonCryptNonProtProd: this.getMulticastValues(multicastNonProt, 'prod', arbitrated),
          cryptNonProtProd: this.getMulticastValues(multicastNonProt, 'crypt_prod', arbitrated),
          cryptNonProtUat: this.getMulticastValues(multicastNonProt, 'crypt_uat', arbitrated),
          nonCryptNonProtUat: this.getMulticastValues(multicastNonProt, 'uat', arbitrated),
          arbitrated: arbitrated
        };
        multicastList.push(multicast);
      }
    }
    return multicastList;
  }

  filterMulticastList() {
    this.utilsService.saveUserData('qedMulticastFilter',
      {
        'pop': this.popForm.value,
        'channel': this.channelForm.value,
        'ipAddress1': this.ipAddress1Form.value,
        'ipAddress2': this.ipAddress2Form.value,
        'ipAddress3': this.ipAddress3Form.value,
        'ipAddress4': this.ipAddress4Form.value,
        'platform': this.platformForm.value,
        'encryption': this.encryptionForm.value,
        'protection': this.protectionForm.value
      });
    let qedArbitratedMulticastList = this.arbitratedQedMulticastList;
    let qedMulticastList = this.qedMulticastList;
    qedArbitratedMulticastList = this.eliminateEmptyMulticast(qedArbitratedMulticastList);
    qedMulticastList = this.eliminateEmptyMulticast(qedMulticastList);
    if (this.popForm.value === ''
      && this.channelForm.value === ''
      && this.ipAddress1Form.value === ''
      && this.ipAddress2Form.value === ''
      && this.ipAddress3Form.value === ''
      && this.ipAddress4Form.value === '') {
      this.filteredValuesArbitrated = (!qedArbitratedMulticastList) ? [] : qedArbitratedMulticastList;
      this.filteredQedMulticastList = (!qedMulticastList) ? [] : qedMulticastList;
      return;
    }
    this.filteredQedMulticastList = (!qedMulticastList) ? [] : this.filters(qedMulticastList);
    this.filteredValuesArbitrated = (!qedArbitratedMulticastList) ? [] : this.filters(qedArbitratedMulticastList);
  }

  eliminateEmptyMulticast(qedMulticastList: QedMulticastList[]) {
    return this.allEncryptionFilter(qedMulticastList);
  }

  colspanEncryptionColumn() {
    if (this.protectionForm.value === 'All' && this.platformForm.value === 'All') {
      return 4;
    } else if (this.protectionForm.value !== 'All' && this.platformForm.value === 'All'
      || this.protectionForm.value === 'All' && this.platformForm.value !== 'All') {
      return 2;
    } else {
      return 1;
    }
  }

  colspanProductionColumn() {
    if (this.platformForm.value === 'All') {
      return 2;
    }
    return 1;
  }

  channelsWithSamePop(pop, arbitrated = false) {
    if (arbitrated === true) {
      return this.filteredValuesArbitrated.filter(qedMulticast =>
        qedMulticast.pop === pop && qedMulticast.arbitrated === arbitrated);
    } else {
      return this.filteredQedMulticastList.filter(qedMulticast =>
        qedMulticast.pop === pop && qedMulticast.arbitrated === arbitrated);
    }
  }

  downloadOptionsChanged($event: Event) {
    // @ts-ignore
    this.downloadOption = $event.target.value;
  }

  verifyDateSelected(rangeDate1 = false, rangeDate2 = false) {
    if (!this.pastDateRange1Form.value || !this.pastDateRange2Form.value) {
      return;
    }
    this.symbolsService.verifyDateSelected(rangeDate1, rangeDate2, this.pastDateRange1Form, this.pastDateRange2Form);
  }

  rangeDateNotSelected() {
    return !this.pastDateRange1Form.value
      || !this.pastDateRange2Form.value;
  }

  downloadCurrentQedMulticastList() {
    this.httpClient.get(environment.baseUrlWs + '/api/multicast-list?service=qed&ui=1').subscribe((response) => {
        const blob = this.symbolsService.b64toBlob(response['file_content'], response['mime_type'], null);
        saveAs(blob, this.applyQhfFilename(response['file_name']));
      }
    );
  }

  downloadRangeQedMulticastList() {
    const startDate = this.datePipe.transform(this.pastDateRange1Form.value, 'yyyy-MM-dd');
    const endDate = this.datePipe.transform(this.pastDateRange2Form.value, 'yyyy-MM-dd');
    this.httpClient.get(environment.baseUrlWs + '/api/multicast-list-by-dates?service=qed&start_date='
      + startDate + '&end_date=' + endDate)
      .subscribe({
        next: (response) => {
          const blob = this.symbolsService.b64toBlob(response['file_content'], response['mime_type'], null);
          saveAs(blob, this.applyQhfFilename(response['file_name']));
        }, error: (error: HttpResponse<any>) => {
          this.utilsService.handleErrorWebservice$(error);
        }
      });
  }

  private applyQhfFilename(filename: string): string {
    return this.isQhf ? filename.replace(/^qed/, 'qhf') : filename;
  }

  resetRangeDates() {
    this.pastDateRange1Form.setValue('');
    this.pastDateRange2Form.setValue('');
  }

  getCommentFromQedSymbolInfoData() {
    return (this.qedSymbolsInfoData && this.qedSymbolsInfoData.comment) ? this.qedSymbolsInfoData.comment : '';
  }

  private getQedSymbolStartDate() {
    this.symbolsService.getSymbolStartDates('qed').subscribe(
      qedSymbolsStartDates => {
        this.startDates = qedSymbolsStartDates;
        this.getDatesArray();
        const disabledDatesStrings = this.dateArray.filter(item => this.startDates.indexOf(item) < 0);
        this.disabledDatesInCalendar = disabledDatesStrings.map(date => new Date(date));
        this.getQedSymbolsInfo();
      }
    );
  }

  private getQedSymbolsInfo() {
    if (!this.startDates || !this.startDates[0]) {
      this.redirectionToNotFound();
    }
    this.getCurrentSymbolInfos();
  }

  private getCurrentSymbolInfos() {
    this.symbolsService.getSymbolInfoBetweenDates(0).subscribe({
        next: qedSymbolsInfo => {
          if (qedSymbolsInfo.length > 0) {
            this.updateOnDate = qedSymbolsInfo[0].updateAt;
            this.qedSymbolsInfo = qedSymbolsInfo[0];
            this.qedSymbolsInfoData = JSON.parse(this.qedSymbolsInfo.data);
            this.getQedMulticastListWithSpecificPlatform();
            return;
          } else {
            this.getSymbolInfoWithFirstStartDate();
          }
        },
        error: () => {
          this.alertQedSymbolHasNotChanged = true;
          this.utilsService.unlockUi();
        }
      }
    );
  }

  private getSymbolInfoWithFirstStartDate() {
    this.symbolsService.getQedSymbolInfoWithStartDate(this.startDates[0], 'qed').subscribe({
        next: qedSymbolsInfo => {
          if (qedSymbolsInfo.length === 1) {
            this.qedSymbolsInfo = qedSymbolsInfo[0];
            this.qedSymbolsInfoData = JSON.parse(this.qedSymbolsInfo.data);
            this.getQedMulticastListWithSpecificPlatform();
          } else {
            this.alertQedSymbolHasNotChanged = true;
            this.utilsService.unlockUi();
          }
        }, error: () => {
          this.alertQedSymbolHasNotChanged = true;
          this.utilsService.unlockUi();
        }
      }
    );
  }

  private getQedMulticastListWithSpecificPlatform() {
    this.symbolsService.getMulticastList('qed', this.qedSymbolsInfo.startDate, false, this.isQhf).subscribe({
      next: res => {
        this.listQedMulticasts = res;
        this.arbitrationPopList = this.createPopList(true);
        this.popList = this.createPopList(false);
        this.qedMulticastList = this.createMulticastList(false);
        this.arbitratedQedMulticastList = this.createMulticastList(true);
        this.filterMulticastList();
        this.utilsService.unlockUi();
      }, error: () => {
        this.utilsService.unlockUi();
        this.redirectionToNotFound();
      }
    });
  }

  private initializeResearchForm(channelName = '', addressGetParameter = '', userChoicesActiveFilters) {
    let addressIp = [];
    if (addressGetParameter !== '') {
      addressIp = addressGetParameter.split('.');
    }
    if (addressIp.length !== 4) {
      addressIp = ['', '', '', ''];
    }
    this.researchForm = this.formBuilder.group({
      pop: userChoicesActiveFilters.pop,
      channel: (channelName) ? channelName : userChoicesActiveFilters.channel,
      ipAddress1: (addressIp[0]) ? addressIp[0] : userChoicesActiveFilters.ipAddress1,
      ipAddress2: userChoicesActiveFilters.ipAddress2,
      ipAddress3: userChoicesActiveFilters.ipAddress3,
      ipAddress4: (addressIp[3]) ? addressIp[3] : userChoicesActiveFilters.ipAddress4,
      platform: userChoicesActiveFilters.platform,
      encryption: userChoicesActiveFilters.encryption,
      protection: userChoicesActiveFilters.protection,
      pastDateRange1: [''],
      pastDateRange2: [''],
    });
    this.subscriptions.push(
      this.pastDateRange1Form.valueChanges.subscribe(() => this.verifyDateSelected(true)),
      this.pastDateRange2Form.valueChanges.subscribe(() => this.verifyDateSelected(false, true))
    );
  }

  private getForm(formName: string): AbstractControl {
    return this.researchForm.get(formName);
  }

  private createPopList(arbitrated) {
    const arbitrationList = this.listQedMulticasts
      .filter(qedMulticast => qedMulticast.arbitration === arbitrated)
      .map(qedMulticast => qedMulticast.popName)
      .sort();
    const listPops = _.uniq(arbitrationList);
    if (arbitrated === false) {
      this.popListDropdown.push('');
    } else {
      this.arbitrationPopListDropDown.push('');
    }
    _.forEach(listPops, (popName: string) => {
      if (arbitrated === false) {
        this.popListDropdown.push(popName);
      } else {
        this.arbitrationPopListDropDown.push(popName);
      }
    });
    return listPops;
  }

  private hasIpAddress(qedMulticast, ipAddress1, ipAddress2, ipAddress3, ipAddress4) {
    const ipAddress = [];
    if ((this.encryptionForm.value === 'All' || this.encryptionForm.value === 'Non-Encrypted')
      && (this.protectionForm.value === 'All' || this.protectionForm.value === 'Non-Protected')
      && (this.platformForm.value === 'All' || this.platformForm.value === 'Prod only')) {
      ipAddress.push(qedMulticast.nonCryptNonProtProd.split('.'));
    }
    if ((this.encryptionForm.value === 'All' || this.encryptionForm.value === 'Non-Encrypted')
      && (this.protectionForm.value === 'All' || this.protectionForm.value === 'Non-Protected')
      && (this.platformForm.value === 'All' || this.platformForm.value === 'UAT only')) {
      ipAddress.push(qedMulticast.nonCryptNonProtUat.split('.'));
    }
    if ((this.encryptionForm.value === 'All' || this.encryptionForm.value === 'Non-Encrypted')
      && (this.protectionForm.value === 'All' || this.protectionForm.value === 'Protected')
      && (this.platformForm.value === 'All' || this.platformForm.value === 'Prod only')) {
      ipAddress.push(qedMulticast.nonCryptProtProd.split('.'));
    }
    if ((this.encryptionForm.value === 'All' || this.encryptionForm.value === 'Non-Encrypted')
      && (this.protectionForm.value === 'All' || this.protectionForm.value === 'Protected')
      && (this.platformForm.value === 'All' || this.platformForm.value === 'UAT only')) {
      ipAddress.push(qedMulticast.nonCryptProtUat.split('.'));
    }
    if ((this.encryptionForm.value === 'All' || this.encryptionForm.value === 'Encrypted')
      && (this.protectionForm.value === 'All' || this.protectionForm.value === 'Non-Protected')
      && (this.platformForm.value === 'All' || this.platformForm.value === 'Prod only')) {
      ipAddress.push(qedMulticast.cryptNonProtProd.split('.'));
    }
    if ((this.encryptionForm.value === 'All' || this.encryptionForm.value === 'Encrypted')
      && (this.protectionForm.value === 'All' || this.protectionForm.value === 'Non-Protected')
      && (this.platformForm.value === 'All' || this.platformForm.value === 'UAT only')) {
      ipAddress.push(qedMulticast.cryptNonProtUat.split('.'));
    }
    if ((this.encryptionForm.value === 'All' || this.encryptionForm.value === 'Encrypted')
      && (this.protectionForm.value === 'All' || this.protectionForm.value === 'Protected')
      && (this.platformForm.value === 'All' || this.platformForm.value === 'Prod only')) {
      ipAddress.push(qedMulticast.cryptProtProd.split('.'));
    }
    if ((this.encryptionForm.value === 'All' || this.encryptionForm.value === 'Encrypted')
      && (this.protectionForm.value === 'All' || this.protectionForm.value === 'Protected')
      && (this.platformForm.value === 'All' || this.platformForm.value === 'UAT only')) {
      ipAddress.push(qedMulticast.cryptProtUat.split('.'));
    }
    for (const ip of ipAddress) {
      let lastOctet;
      if (typeof ip[3] !== 'undefined') {
        lastOctet = ip[3].substr(ip.lastIndexOf('.') + 1).split('/')[0];
      }
      if (!(ipAddress1 !== '' && ip[0] !== ipAddress1
        || ipAddress2 !== '' && (!ip[1] || ip[1] !== ipAddress2)
        || ipAddress3 !== '' && (!ip[2] || ip[2] !== ipAddress3)
        || ipAddress4 !== '' && (!lastOctet || lastOctet !== ipAddress4))) {
        return true;
      }
    }
    return false;
  }

  private getPortOrMcastIp(multicast: QedMulticast[], arbitration: boolean) {
    if (multicast.length > 0) {
      for (let cpt = 0; cpt < multicast.length; cpt++) {
        if ((!arbitration && !multicast[cpt].arbitration) || (arbitration && multicast[cpt].arbitration)) {
          return multicast[0].mcastIp;
        }
      }
    }
    return '';
  }

  private allEncryptionFilter(qedMulticastList: QedMulticastList[]) {
    if (this.platformForm.value === 'All' && this.protectionForm.value === 'All') {
      if (this.encryptionForm.value === 'All') {
        return qedMulticastList.filter(qedMulticast =>
          qedMulticast.nonCryptProtProd !== ''
          || qedMulticast.nonCryptProtUat !== ''
          || qedMulticast.nonCryptNonProtProd !== ''
          || qedMulticast.nonCryptNonProtUat !== ''
          || qedMulticast.cryptProtProd !== ''
          || qedMulticast.cryptProtUat !== ''
          || qedMulticast.cryptNonProtProd !== ''
          || qedMulticast.cryptNonProtUat !== '');
      } else if (this.encryptionForm.value === 'Non-Encrypted') {
        return qedMulticastList.filter(qedMulticast =>
          qedMulticast.nonCryptProtProd !== ''
          || qedMulticast.nonCryptProtUat !== ''
          || qedMulticast.nonCryptNonProtProd !== ''
          || qedMulticast.nonCryptNonProtUat !== '');
      }
      return qedMulticastList.filter(qedMulticast =>
        qedMulticast.cryptProtProd !== ''
        || qedMulticast.cryptProtUat !== ''
        || qedMulticast.cryptNonProtProd !== ''
        || qedMulticast.cryptNonProtUat !== '');
    }
    if (this.platformForm.value === 'All' && this.protectionForm.value === 'Non-Protected') {
      if (this.encryptionForm.value === 'All') {
        return qedMulticastList.filter(qedMulticast =>
          qedMulticast.nonCryptNonProtProd !== ''
          || qedMulticast.nonCryptNonProtUat !== ''
          || qedMulticast.cryptNonProtProd !== ''
          || qedMulticast.cryptNonProtUat !== '');
      } else if (this.encryptionForm.value === 'Non-Encrypted') {
        return qedMulticastList.filter(qedMulticast =>
          qedMulticast.nonCryptNonProtProd !== ''
          || qedMulticast.nonCryptNonProtUat !== '');
      }
      return qedMulticastList.filter(qedMulticast =>
        qedMulticast.cryptNonProtProd !== ''
        || qedMulticast.cryptNonProtUat !== '');
    }
    if (this.platformForm.value === 'All' && this.protectionForm.value === 'Protected') {
      if (this.encryptionForm.value === 'All') {
        return qedMulticastList.filter(qedMulticast =>
          qedMulticast.nonCryptProtProd !== ''
          || qedMulticast.nonCryptProtUat !== ''
          || qedMulticast.cryptProtProd !== ''
          || qedMulticast.cryptProtUat !== '');
      } else if (this.encryptionForm.value === 'Non-Encrypted') {
        return qedMulticastList.filter(qedMulticast =>
          qedMulticast.nonCryptProtProd !== ''
          || qedMulticast.nonCryptProtUat !== '');
      }
      return qedMulticastList.filter(qedMulticast =>
        qedMulticast.cryptProtProd !== ''
        || qedMulticast.cryptProtUat !== '');
    }
    if (this.platformForm.value === 'Prod only' && this.protectionForm.value === 'All') {
      if (this.encryptionForm.value === 'All') {
        return qedMulticastList.filter(qedMulticast =>
          qedMulticast.nonCryptProtProd !== ''
          || qedMulticast.nonCryptNonProtProd !== ''
          || qedMulticast.cryptProtProd !== ''
          || qedMulticast.cryptNonProtProd !== '');
      } else if (this.encryptionForm.value === 'Non-Encrypted') {
        return qedMulticastList.filter(qedMulticast =>
          qedMulticast.nonCryptProtProd !== ''
          || qedMulticast.nonCryptNonProtProd !== '');
      }
      return qedMulticastList.filter(qedMulticast =>
        qedMulticast.cryptProtProd !== ''
        || qedMulticast.cryptNonProtProd !== '');
    }
    if (this.platformForm.value === 'UAT only' && this.protectionForm.value === 'All') {
      if (this.encryptionForm.value === 'All') {
        return qedMulticastList.filter(qedMulticast =>
          qedMulticast.nonCryptProtUat !== ''
          || qedMulticast.nonCryptNonProtUat !== ''
          || qedMulticast.cryptProtUat !== ''
          || qedMulticast.cryptNonProtUat !== '');
      } else if (this.encryptionForm.value === 'Non-Encrypted') {
        return qedMulticastList.filter(qedMulticast =>
          qedMulticast.nonCryptProtUat !== ''
          || qedMulticast.nonCryptNonProtUat !== '');
      }
      return qedMulticastList.filter(qedMulticast =>
        qedMulticast.cryptProtUat !== ''
        || qedMulticast.cryptNonProtUat !== '');
    }
    if (this.platformForm.value === 'Prod only' && this.protectionForm.value === 'Non-Protected') {
      if (this.encryptionForm.value === 'All') {
        return qedMulticastList.filter(qedMulticast =>
          qedMulticast.nonCryptNonProtProd !== ''
          || qedMulticast.cryptNonProtProd !== '');
      } else if (this.encryptionForm.value === 'Non-Encrypted') {
        return qedMulticastList.filter(qedMulticast =>
          qedMulticast.nonCryptNonProtProd !== '');
      }
      return qedMulticastList.filter(qedMulticast =>
        qedMulticast.cryptNonProtProd !== '');
    }
    if (this.platformForm.value === 'Prod only' && this.protectionForm.value === 'Protected') {
      if (this.encryptionForm.value === 'All') {
        return qedMulticastList.filter(qedMulticast =>
          qedMulticast.nonCryptProtProd !== ''
          || qedMulticast.cryptProtProd !== '');
      } else if (this.encryptionForm.value === 'Non-Encrypted') {
        return qedMulticastList.filter(qedMulticast =>
          qedMulticast.nonCryptProtProd !== '');
      }
      return qedMulticastList.filter(qedMulticast =>
        qedMulticast.cryptProtProd !== '');
    }
    if (this.platformForm.value === 'UAT only' && this.protectionForm.value === 'Non-Protected') {
      if (this.encryptionForm.value === 'All') {
        return qedMulticastList.filter(qedMulticast =>
          qedMulticast.nonCryptNonProtUat !== ''
          || qedMulticast.cryptNonProtUat !== '');
      } else if (this.encryptionForm.value === 'Non-Encrypted') {
        return qedMulticastList.filter(qedMulticast =>
          qedMulticast.nonCryptNonProtUat !== '');
      }
      return qedMulticastList.filter(qedMulticast =>
        qedMulticast.cryptNonProtUat !== '');
    }
    if (this.platformForm.value === 'UAT only' && this.protectionForm.value === 'Protected') {
      if (this.encryptionForm.value === 'All') {
        return qedMulticastList.filter(qedMulticast =>
          qedMulticast.nonCryptProtUat !== ''
          || qedMulticast.cryptProtUat !== '');
      } else if (this.encryptionForm.value === 'Non-Encrypted') {
        return qedMulticastList.filter(qedMulticast =>
          qedMulticast.nonCryptProtUat !== '');
      }
      return qedMulticastList.filter(qedMulticast =>
        qedMulticast.cryptProtUat !== '');
    }
  }

  private filters(filteredMulticastList: QedMulticastList[]) {
    filteredMulticastList = this.filterByPop(filteredMulticastList);
    filteredMulticastList = this.filterByChannel(filteredMulticastList);
    if (this.ipAddress1Form.value !== ''
      || this.ipAddress2Form.value !== ''
      || this.ipAddress3Form.value !== ''
      || this.ipAddress4Form.value !== '') {
      filteredMulticastList = this.filterByAddressIp(filteredMulticastList);
    }
    return filteredMulticastList;
  }

  private filterByAddressIp(filteredMulticastList: QedMulticastList[]) {
    return filteredMulticastList.filter(qedMulticast =>
      this.hasIpAddress(qedMulticast,
        this.ipAddress1Form.value,
        this.ipAddress2Form.value,
        this.ipAddress3Form.value,
        this.ipAddress4Form.value));
  }

  private filterByChannel(filteredMulticastList: QedMulticastList[]) {
    if (this.channelForm.value === '' || this.channelForm.value === null) {
      return filteredMulticastList;
    }
    return filteredMulticastList.filter(qedMulticast => qedMulticast.channel.toLowerCase().includes(this.channelForm.value.toLowerCase()));
  }

  private filterByPop(filteredMulticastList: QedMulticastList[]) {
    if (this.popForm.value === '' || this.popForm.value === null) {
      return filteredMulticastList;
    }
    return filteredMulticastList.filter(qedMulticast => qedMulticast.pop === this.popForm.value);
  }

  onPasteIp(event: ClipboardEvent) {
    let ipAddress = event.clipboardData?.getData('text') || '';
    ipAddress = ipAddress.trim();
    const parts = ipAddress.split('.');
    if (parts.length === 4) {
      this.researchForm.patchValue({
        ipAddress1: parts[0], ipAddress2: parts[1],
        ipAddress3: parts[2], ipAddress4: parts[3],
      });
      event.preventDefault();
    }
    if (parts.length === 3) {
      this.researchForm.patchValue({
        ipAddress1: parts[0], ipAddress2: parts[1],
        ipAddress3: parts[2],
      });
      event.preventDefault();
    }
    if (parts.length === 2) {

      this.researchForm.patchValue({
        ipAddress1: parts[0], ipAddress2: parts[1]
      });
      event.preventDefault();
    }
    this.filterMulticastList();
  }
}
